export class BookingStatusModel {
    orderStatus: string;
    paymentStatus: string;
    bookingStatus: string;
    cancelStatus: string;

    constructor(orderStatus?: string, paymentStatus?: string, bookingStatus?: string, cancelStatus?: string) {
        this.orderStatus = orderStatus;
        this.paymentStatus = paymentStatus;
        this.bookingStatus = bookingStatus;
        this.cancelStatus = cancelStatus;
    }
}
export class BookingStatusV2Model {
    status: string;

    constructor(status?: string) {
        this.status = status;
    }
}


// WEBPACK FOOTER //
// ./src/app/model/booking/booking-status-model.ts